import { MessageCircle } from "lucide-react";

// Discreet private WhatsApp advisor link. Not a floating chat balloon.
// Used inside product pages as a "concierge appointment" link.
export default function StyleAdvisor({ product, size, color }) {
  const msg = encodeURIComponent(
    `Hello LOOXS Concierge, I would like to arrange a styling appointment${product ? ` for the ${product.name}` : ""}${size ? ` — size ${size}` : ""}${color ? `, colour ${color}` : ""}.`
  );
  const href = `https://wa.me/919999999999?text=${msg}`;
  return (
    <a href={href} target="_blank" rel="noreferrer" data-testid="style-advisor-link"
       className="mt-4 flex items-center justify-center gap-3 border border-ink/25 py-3 text-[11px] tracking-widest-plus uppercase hover:border-goldDark hover:text-goldDark transition-colors duration-500 w-full">
      <MessageCircle className="w-4 h-4" strokeWidth={1.25} /> Speak to a LOOXS advisor
    </a>
  );
}
